import React ,{useEffect,useState} from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Button, Modal, UncontrolledTooltip } from "reactstrap";

export  const EventFollowUpDownload=(props)=> {
  
  const {handleClose, handleSave, value } = props;  
  const [open, Setopen] = useState(true)
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const closeOpen=(e)=>{
    e.preventDefault();
    props.closeUserView();
    Setopen(false);
  }

  
  const downloadFollowUpDoc = () => {
    document.getElementById('downloadClick').click();
  }
  return (
    <div>
       <Modal  className="modal-dialog-centered"  style={{maxWidth:"490px",maxHeight:"460px"}}  isOpen={open}>
             <><div className="modal-header">
              <strong>Event Follow Up</strong> 
              <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={ closeOpen}>
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div style = {{ marginLeft:"45px"}}>
              <img src="/images/chMeetingFollowUp.png" alt="Meeting Follow Up" style = {{ height:"500px"}} />       
               <Button className="downloadFollowUp down-btn-red" style={{border:"none", marginLeft:"160px",  marginTop:"-6rem"}} onClick={() => downloadFollowUpDoc()}>Download</Button>   
               <a className='down-exhibitor' download='/pdf/CHANNEL_SUMMIT_LEAD_FOLLOW_UP.pdf' href='/pdf/CHANNEL_SUMMIT_LEAD_FOLLOW_UP.pdf' id="downloadClick" title='Download EventFollow Up Guide PDF' style={{display:'none'}} > <i class="fa fa-download" aria-hidden="true" ></i> Download </a>      
            </div>
            <div className="modal-footer">
               <Button color="secondary" data-dismiss="modal" type="button"  onClick={closeOpen}>Close</Button>
            </div>
            </>
       </Modal>
    </div>
  );
}

export default  EventFollowUpDownload;